import {AxiosResponse} from "axios";
import api from "../api";

export class AppService {
    public listApplicationCountries(): Promise<AxiosResponse<any>> {
        return api.get(`/country/`);
    }

    public findAddress(request: any): Promise<AxiosResponse<any>> {
        return api.post(`/address_checker/find_address`, request);
    }

    private handleMenuGroup (menu: any, allowedLinks: string[]) {
        return menu.filter((obj: any) => {
            return allowedLinks.includes(obj.item_enum);
        }).map((obj: any) => {
            if (obj.children.length > 0) {
                obj.children = this.handleMenuGroup(obj.children, allowedLinks);
            }
            return obj;
        });
    }

    public fetchMenu = () => {
        return api.get('/user_administration/my_account/allowed_menu_items').then(({ data }) => {
            return this.handleMenuGroup([
                {
                    name: 'userMenuItemEnum.homepage',
                    item_enum: 'homepage',
                    bo_path: null,
                    fo_uri: null,
                    bo_uri: '/',
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.my_account',
                    item_enum: 'my_account',
                    bo_path: 'my_account_view',
                    fo_uri: null,
                    bo_uri: '/my_account',
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.dashboard',
                    item_enum: 'dashboard',
                    bo_path: null,
                    fo_uri: '/dashboard',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.customers',
                    item_enum: 'customers',
                    bo_path: null,
                    fo_uri: '/customer',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.status_update_overview',
                    item_enum: 'status_update_overview',
                    bo_path: null,
                    fo_uri: '/status_update_overview',
                    bo_uri: null,
                    children: [],
                },
//Support subjects singles
                {
                    name: 'userMenuItemEnum.help_documents',
                    item_enum: 'help_documents',
                    bo_path: null,
                    fo_uri: '/cls/ClsHelpDocumentFile/documents',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.interface_logs',
                    item_enum: 'interface_logs',
                    bo_path: null,
                    fo_uri: '/interface_logs',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.hdn_client',
                    item_enum: 'hdn_client',
                    bo_path: null,
                    fo_uri: '/hdn/tp/lx/send',
                    bo_uri: null,
                    children: [],
                },
//Support subjects group
                {
                    name: 'userMenuGroup.support_subjects',
                    item_enum: null,
                    bo_path: null,
                    fo_uri: null,
                    bo_uri: null,
                    children: [
                        {
                            name: 'userMenuItemEnum.help_documents',
                            item_enum: 'help_documents_grouped',
                            bo_path: null,
                            fo_uri: '/cls/ClsHelpDocumentFile/documents',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.interface_logs',
                            item_enum: 'interface_logs_grouped',
                            bo_path: null,
                            fo_uri: '/interface_logs',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.hdn_client',
                            item_enum: 'hdn_client_grouped',
                            bo_path: null,
                            fo_uri: '/hdn/tp/lx/send',
                            bo_uri: null,
                            children: [],
                        },
                    ]
                },
//#Customer process singles
                {
                    name: 'userMenuItemEnum.advice_new',
                    item_enum: 'advice_new',
                    bo_path: null,
                    fo_uri: '/advice/new',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.offer_new',
                    item_enum: 'offer_new',
                    bo_path: null,
                    fo_uri: '/offer/new',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.offers',
                    item_enum: 'offers',
                    bo_path: null,
                    fo_uri: '/offer',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.applications',
                    item_enum: 'applications',
                    bo_path: null,
                    fo_uri: '/application',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.application_invoices',
                    item_enum: 'application_invoices',
                    bo_path: null,
                    fo_uri: '/application_invoices',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.egv',
                    item_enum: 'egv',
                    bo_path: null,
                    fo_uri: '/eGV',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.policies',
                    item_enum: 'policies',
                    bo_path: null,
                    fo_uri: '/policy',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.claims',
                    item_enum: 'claims',
                    bo_path: null,
                    fo_uri: '/claim',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.claim_payments',
                    item_enum: 'claim_payments',
                    bo_path: null,
                    fo_uri: '/claim_payments',
                    bo_uri: null,
                    children: [],
                },
//Customer process group
                {
                    name: 'userMenuGroup.customer_process',
                    item_enum: null,
                    bo_path: null,
                    fo_uri: null,
                    bo_uri: null,
                    children: [
                        {
                            name: 'userMenuItemEnum.advice_new',
                            item_enum: 'advice_new_grouped',
                            bo_path: null,
                            fo_uri: '/advice/new',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.offer_new',
                            item_enum: 'offer_new_grouped',
                            bo_path: null,
                            fo_uri: '/offer/new',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.offers',
                            item_enum: 'offers_grouped',
                            bo_path: null,
                            fo_uri: '/offer',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.applications',
                            item_enum: 'applications_grouped',
                            bo_path: null,
                            fo_uri: '/application',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.application_invoices',
                            item_enum: 'application_invoices_grouped',
                            bo_path: null,
                            fo_uri: '/application_invoices',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.egv',
                            item_enum: 'egv_grouped',
                            bo_path: null,
                            fo_uri: '/eGV',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.policies',
                            item_enum: 'policies_grouped',
                            bo_path: null,
                            fo_uri: '/policy',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.claims',
                            item_enum: 'claims_grouped',
                            bo_path: null,
                            fo_uri: '/claim',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.claim_payments',
                            item_enum: 'claim_payments_grouped',
                            bo_path: null,
                            fo_uri: '/claim_payments',
                            bo_uri: null,
                            children: [],
                        },
                    ]
                },
//Users/Companies singles
                {
                    name: 'userMenuItemEnum.users',
                    item_enum: 'users',
                    bo_path: 'user_list',
                    fo_uri: null,
                    bo_uri: '/user',
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.fo_users',
                    item_enum: 'fo_users',
                    bo_path: null,
                    fo_uri: '/user',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.servicers',
                    item_enum: 'servicers',
                    bo_path: 'servicer_list',
                    fo_uri: null,
                    bo_uri: '/servicer',
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.agencies',
                    item_enum: 'agencies',
                    bo_path: 'agency_list',
                    fo_uri: null,
                    bo_uri: '/agency',
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.external_medical_companies',
                    item_enum: 'external_medical_companies',
                    bo_path: null,
                    fo_uri: '/external_medical_company',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.insurance_companies',
                    item_enum: 'insurance_companies',
                    bo_path: null,
                    fo_uri: '/insurance_company',
                    bo_uri: null,
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.banks',
                    item_enum: 'banks',
                    bo_path: 'bank_list',
                    fo_uri: null,
                    bo_uri: '/bank',
                    children: [],
                },
                {
                    name: 'userMenuItemEnum.other_company',
                    item_enum: 'other_company',
                    bo_path: 'other_company_list',
                    fo_uri: null,
                    bo_uri: '/other_company',
                    children: [],
                },
//Users/Companies group
                {
                    name: 'userMenuGroup.users_and_companies',
                    item_enum: null,
                    bo_path: null,
                    fo_uri: null,
                    bo_uri: null,
                    children: [
                        {
                            name: 'userMenuItemEnum.users',
                            item_enum: 'users_grouped',
                            bo_path: 'user_list',
                            fo_uri: null,
                            bo_uri: '/user',
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.fo_users',
                            item_enum: 'fo_users_grouped',
                            bo_path: null,
                            fo_uri: '/user',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.servicers',
                            item_enum: 'servicers_grouped',
                            bo_path: 'servicer_list',
                            fo_uri: null,
                            bo_uri: '/servicer',
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.agencies',
                            item_enum: 'agencies_grouped',
                            bo_path: 'agency_list',
                            fo_uri: null,
                            bo_uri: '/agency',
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.external_medical_companies',
                            item_enum: 'external_medical_companies_grouped',
                            bo_path: null,
                            fo_uri: '/external_medical_company',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.insurance_companies',
                            item_enum: 'insurance_companies_grouped',
                            bo_path: null,
                            fo_uri: '/insurance_company',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.banks',
                            item_enum: 'banks_grouped',
                            bo_path: 'bank_list',
                            fo_uri: null,
                            bo_uri: '/bank',
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.other_company',
                            item_enum: 'other_company_grouped',
                            bo_path: 'other_company_list',
                            fo_uri: null,
                            bo_uri: '/other_company',
                            children: [],
                        },
                    ]
                },
//#Reports group
                {
                    name: 'userMenuGroup.reports',
                    item_enum: null,
                    bo_path: null,
                    fo_uri: null,
                    bo_uri: null,
                    children: [
                        {
                            name: 'userMenuItemEnum.offer_report',
                            item_enum: 'offer_report',
                            bo_path: null,
                            fo_uri: '/report/offer',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.maex_offer_report',
                            item_enum: 'maex_offer_report',
                            bo_path: null,
                            fo_uri: '/report/maexOffer',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.advice_report',
                            item_enum: 'advice_report',
                            bo_path: null,
                            fo_uri: '/report/advice',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.application_report',
                            item_enum: 'application_report',
                            bo_path: null,
                            fo_uri: '/report/application',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.application_management_report',
                            item_enum: 'application_management_report',
                            bo_path: null,
                            fo_uri: '/report/application_management',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.application_invoice_bookkeeping_report',
                            item_enum: 'application_invoice_bookkeeping_report',
                            bo_path: null,
                            fo_uri: '/report/application_invoice_bookkeeping',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.claim_payment_bookkeeping_report',
                            item_enum: 'claim_payment_bookkeeping_report',
                            bo_path: null,
                            fo_uri: '/report/claim_payment_bookkeeping',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.claim_management_information_report',
                            item_enum: 'claim_management_information_report',
                            bo_path: null,
                            fo_uri: '/report/claim_management_information',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.egv_report',
                            item_enum: 'egv_report',
                            bo_path: null,
                            fo_uri: '/report/egv',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.hubspot_report',
                            item_enum: 'hubspot_report',
                            bo_path: null,
                            fo_uri: '/report/hubspot',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.dashboard_report',
                            item_enum: 'dashboard_report',
                            bo_path: null,
                            fo_uri: '/report/dashboard',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.agency_activity_report',
                            item_enum: 'agency_activity_report',
                            bo_path: null,
                            fo_uri: '/report/agency_activity',
                            bo_uri: null,
                            children: [],
                        },
                    ]
                },
//Content settings/configurations group
                {
                    name: 'userMenuGroup.content_settings_and_configurations',
                    item_enum: null,
                    bo_path: null,
                    fo_uri: null,
                    bo_uri: null,
                    children: [
                        {
                            name: 'userMenuItemEnum.classifiers',
                            item_enum: 'classifiers',
                            bo_path: null,
                            fo_uri: '/classifier',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.roles',
                            item_enum: 'roles',
                            bo_path: 'role_list',
                            fo_uri: null,
                            bo_uri: '/role',
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.fo_roles',
                            item_enum: 'fo_roles',
                            bo_path: null,
                            fo_uri: '/role',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.professions',
                            item_enum: 'professions',
                            bo_path: null,
                            fo_uri: '/cls_profession',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.questionnaire_profession_rules',
                            item_enum: 'questionnaire_profession_rules',
                            bo_path: null,
                            fo_uri: '/questionnaire_profession_rule',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.article',
                            item_enum: 'article',
                            bo_path: null,
                            fo_uri: '/article',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.email_template',
                            item_enum: 'email_template',
                            bo_path: null,
                            fo_uri: '/email_template',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.setting',
                            item_enum: 'setting',
                            bo_path: null,
                            fo_uri: '/setting',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.minimum_wage_settings',
                            item_enum: 'minimum_wage_settings',
                            bo_path: null,
                            fo_uri: '/minimum_wage_setting',
                            bo_uri: null,
                            children: [],
                        },
                    ]
                },
//#Translations group
                {
                    name: 'userMenuGroup.translations',
                    item_enum: null,
                    bo_path: null,
                    fo_uri: null,
                    bo_uri: null,
                    children: [
                        {
                            name: 'userMenuItemEnum.translations',
                            item_enum: 'translations',
                            bo_path: 'translator_invalidate_cache',
                            fo_uri: null,
                            bo_uri: '/translation',
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.alias_translation_import',
                            item_enum: 'alias_translation_import',
                            bo_path: 'translator_import_alias_translation',
                            fo_uri: null,
                            bo_uri: '/translation_import',
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.entity_translation_import',
                            item_enum: 'entity_translation_import',
                            bo_path: 'translator_import_entity_translation',
                            fo_uri: null,
                            bo_uri: '/translation_entity_import',
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.fo_translations',
                            item_enum: 'fo_translations',
                            bo_path: null,
                            fo_uri: '/translate/grid',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.fo_alias_translation_import',
                            item_enum: 'fo_alias_translation_import',
                            bo_path: null,
                            fo_uri: '/aliasTranslationImport',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.fo_entity_translation_import',
                            item_enum: 'fo_entity_translation_import',
                            bo_path: null,
                            fo_uri: '/entityTranslationImport',
                            bo_uri: null,
                            children: [],
                        },
                    ]
                },
//#Applications settings group
                {
                    name: 'userMenuGroup.applications_settings',
                    item_enum: null,
                    bo_path: null,
                    fo_uri: null,
                    bo_uri: null,
                    children: [
                        {
                            name: 'userMenuItemEnum.diseases',
                            item_enum: 'diseases',
                            bo_path: null,
                            fo_uri: '/disease',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.rules',
                            item_enum: 'rules',
                            bo_path: null,
                            fo_uri: '/rule',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.application_amount_limit',
                            item_enum: 'application_amount_limit',
                            bo_path: null,
                            fo_uri: '/application_amount_limit',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.company_blacklist',
                            item_enum: 'company_blacklist',
                            bo_path: null,
                            fo_uri: '/company_blacklist',
                            bo_uri: null,
                            children: [],
                        },
                    ]
                },
//#Claim settings group
                {
                    name: 'userMenuGroup.claim_settings',
                    item_enum: null,
                    bo_path: null,
                    fo_uri: null,
                    bo_uri: null,
                    children: [
                        {
                            name: 'userMenuItemEnum.claim_payment_type',
                            item_enum: 'claim_payment_type',
                            bo_path: null,
                            fo_uri: '/payment_type',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.claim_payment_standard_recipients',
                            item_enum: 'claim_payment_standard_recipients',
                            bo_path: null,
                            fo_uri: '/claim_payment_standard_recipient',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.claim_payment_reference_number',
                            item_enum: 'claim_payment_reference_number',
                            bo_path: null,
                            fo_uri: '/claim_payment_reference_number',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.claim_payment_limit',
                            item_enum: 'claim_payment_limit',
                            bo_path: null,
                            fo_uri: '/claim_payment_limit',
                            bo_uri: null,
                            children: [],
                        },
                        {
                            name: 'userMenuItemEnum.igp_indexation',
                            item_enum: 'igp_indexation',
                            bo_path: null,
                            fo_uri: '/igp_indexation',
                            bo_uri: null,
                            children: [],
                        },
                    ],
                },
            ], [...data, null]);
        });
    }
}